
import { Telemetry, ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

export const byollmTermsAcceptedEventType = 'site_byollm_terms_accepted';
export const UPRA_TERMS_VERSION = '1.0';

export interface ByollmTermsAcceptedEvent extends ValidTelemetryEvent {
  type: string;
  terms_version: string;
}

export function sendByollmTermsAcceptedTelemetry() {
  Telemetry.sendEvent<ByollmTermsAcceptedEvent>({
    type: byollmTermsAcceptedEventType,
    terms_version: UPRA_TERMS_VERSION
  });
}
